/**
 * UX-D04 — PostHog group/tenant helpers.
 *
 * Thin wrapper over `posthog-js`. The actual init lives in
 * `src/lib/analytics/posthog_provider.ts`; this module exposes
 * tenant-aware helpers so the rest of the app does not need to
 * touch `posthog-js` directly.
 */
import posthog from 'posthog-js';
import { isPostHogActive } from '@/lib/analytics';

export { useFeatureFlag } from '@/hooks/useFeatureFlag';

export function setOrganizationGroup(org: { id: string; name?: string; plan?: string } | null) {
  if (!isPostHogActive()) return;
  try {
    if (!org) {
      posthog.resetGroups?.();
      return;
    }
    posthog.group('organization', org.id, {
      name: org.name,
      plan: org.plan,
    });
  } catch {
    // swallow — analytics must never break the app
  }
}
